import React from "react";
import {withFeatureFlags} from "../../../../../userProfile/featureFlagsContext";
import { withAppConfig } from "../../../../../appConfigContext";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import ProImagesPopup from "./ProImagesPopup"

class ViewProImages extends React.Component {
  constructor(props) {
    super(props);
    const showProImagesInPopup = this.props.featureFlags.featureFlags.find(
        (ele) => ele.id == "ShowProImagesInPopup"
      )?.value;
    this.state = {
      isPopup: showProImagesInPopup,
      imagesWebUrl:  this.getImagesWebURL(showProImagesInPopup)
    };
  }

  getImagesWebURL = (showProImagesInPopup) =>  {
    const { proNumber, configJSON, enqueueSnackbar, onClose } = this.props;
    const updatedProNumber = configJSON.proMinLengthForImage
      ? proNumber.padStart(configJSON.proMinLengthForImage, 0)
      : proNumber;
    let imagesWebUrl = configJSON.proImagesUrl;
    if(imagesWebUrl){
      imagesWebUrl = imagesWebUrl.replace("${0}", updatedProNumber);
    }
    
    if (showProImagesInPopup) {
     return imagesWebUrl
    } else {
      if (imagesWebUrl) {
        window.open(imagesWebUrl);
      } else {
        enqueueSnackbar("Pro images url not available", { variant: "error" });
      }
      onClose();
    }
  }

  render() {
    if (!this.state.isPopup) {
      return null;
    }

    return <ProImagesPopup {...this.props} url={this.state.imagesWebUrl} />;
  }
}

export default compose(withAppConfig,withFeatureFlags, withSnackbar)(ViewProImages);
